/**
 * Circular arrows around a check: the run-history marker for when the workflow
 * was published. Filled rather than stroked, so it tints via `fill`, but takes
 * the same `size` and `className` props as the lucide icons beside it.
 */
export function ChangesPublishedIcon({
  className,
  size = 14,
}: {
  className?: string;
  size?: number;
}) {
  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 14 14'
      fill='none'
      className={className}
      aria-hidden='true'
    >
      <path
        d='M10.44 4.98667L5.72667 9.7L2.9 6.87333L3.84 5.93333L5.72667 7.82L9.5 4.04667L10.44 4.98667ZM1.33333 6.63333C1.33333 5.08 2.01333 3.68667 3.08 2.71333L4.66667 4.3V0.3H0.666667L2.13333 1.76667C0.826666 2.98 0 4.70667 0 6.63333C0 10.0933 2.63333 12.9333 6 13.2667V11.92C3.37333 11.5933 1.33333 9.34667 1.33333 6.63333ZM13.3333 6.63333C13.3333 3.17333 10.7 0.333333 7.33333 0V1.34667C9.96 1.67333 12 3.92 12 6.63333C12 8.18667 11.32 9.58 10.2533 10.5533L8.66667 8.96667V12.9667H12.6667L11.2 11.5C12.5067 10.2867 13.3333 8.56 13.3333 6.63333Z'
        fill='currentColor'
      />
    </svg>
  );
}
